import { render, staticRenderFns } from "./StateGovernmentDeclar.vue?vue&type=template&id=207969ee&scoped=true&"
import script from "./StateGovernmentDeclar.vue?vue&type=script&lang=js&"
export * from "./StateGovernmentDeclar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207969ee",
  null
  
)

export default component.exports